const config = {
  brand: 'ELRET',
  brandName: 'ELRET',
  appTld: 'elret.ro',
  termsUrl: 'https://elret.ro/terms-of-use/',
  privacyUrl: 'https://elret.ro/privacy-policy/',
};

export default config;
